@if (!isLoading) {
  <div class="columns is-multiline">
    <div class="column is-12">
      @if (cartonGroupings.length > 0) {
        <agx-pivot-table
          [columnMappings]="columnMappings"
          [(selectedColumns)]="selectedColumns"
          [aggregatedColumns]="aggregatedColumns"
          [data]="cartonGroupings"
          [isLoading]="isLoading"
        />
      } @else {
        <div
          class="box rounded-xl border bg-white shadow-sm"
          [class.is-loading]="isLoading"
        >
          <div class="has-text-centered">
            <h1 class="title mt-5">No pallets found</h1>
            <h2 class="subtitle mt-3">
              Try changing the filters or search term
            </h2>
            <img
              class="empty-state my-5"
              src="assets/images/empty-state/empty-pallets-min.png"
            />
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <ag-shimmer-loader />
}
